import React from 'react';

import { DialogContext } from '@cvt/contexts';

import { Authenticated, NotAuthenticated } from '@modules/Auth/components';
import { InviteTeamMemberDialog } from '@modules/Users/dialogs/InviteTeamMember';
import { MediaLightboxDialog } from '@modules/Users/dialogs/MediaLightbox';
import { AuthenticationDialog } from '@modules/Users/dialogs/AuthenticationDialog';
import { SavingTributeDialog } from '@modules/Tributes/dialogs/SavingTributeDialog';
import { CreateTributeCardDialog } from '@modules/Users/dialogs/CreateTributeCardDialog';
import { CreatingGiftDialog } from '@modules/Tributes/dialogs/CreatingGiftDialog';
import { FAQDialog } from '@modules/Info/dialogs/FAQDialog';
import { HelpDialog } from '@modules/Info/dialogs/HelpDialog';

export const Dialogs = () => {
  const { openedDialogs, closeDialog, dialogOptions } = React.useContext(DialogContext);

  return (
    <React.Fragment>
      <Authenticated>
        <InviteTeamMemberDialog open={!!openedDialogs['inviteTeamMember']} onClose={() => closeDialog('inviteTeamMember')} />
        {!!openedDialogs['createTributeCard'] && (
          <CreateTributeCardDialog open onClose={() => closeDialog('createTributeCard')} options={dialogOptions?.createTributeCard} />
        )}
      </Authenticated>
      {!!openedDialogs['mediaLightbox'] && (
        <MediaLightboxDialog open onClose={() => closeDialog('mediaLightbox')} options={dialogOptions?.mediaLightbox} />
      )}
      {!!openedDialogs['savingTribute'] && (
        <SavingTributeDialog open onClose={() => closeDialog('savingTribute')} />
      )}
      {!!openedDialogs['creatingGift'] && (
        <CreatingGiftDialog open onClose={() => closeDialog('creatingGift')} />
      )}
      <FAQDialog open={!!openedDialogs['faq']} onClose={() => closeDialog('faq')} />
      <HelpDialog open={!!openedDialogs['help']} onClose={() => closeDialog('help')} />
      <NotAuthenticated>
        {!!openedDialogs['authentication'] && (
          <AuthenticationDialog open onClose={() => closeDialog('authentication')} options={dialogOptions?.authentication} />
        )}
      </NotAuthenticated>
    </React.Fragment>
  );
};
